import * as ActionTypes from "../Actions/ActionTypes";
import { updateObject } from "../Utility";
import { PARTIAL_PAYOUT_HANDLER_INSERT_NEW } from "../../Communication/Preferences";

const initialState = {
  initialLiveSetInfo: {},
  activeLiveSports: null,
  activePrematchSports: null,
  liveMatchesList: null,
  allBetsText: null,
  allBets: null,
  updateStampKData: 0,
  updateStampOData: 0,
  updateStampOText: 0,
  updateStampUData: 0,
  updateStampUText: 0,
  prematchLeagueItems: null,
  prematchCategories: null,
  updateTimestamp: new Date()
};

const reducer = (state = initialState, action) => {
  let processedItems = null;

  switch (action.type) {
    case ActionTypes.SPORT_EVENT_SET_LIVE_INITIAL_SET:
      processedItems = processInitialSetData(action.setInfo);

      console.log("PROCESSED INITIAL ITEMS: ", processedItems);

      return updateObject(state, {
        initialLiveSetInfo: action.setInfo,
        activeLiveSports: processedItems.pickerInfos,
        liveMatchesList: processedItems.liveEventList,
        allBetsText: processedItems.allBetsText,
        allBets: processedItems.allBets,
        updateStampKData: action.setInfo.maxUpdateStampKData,
        updateStampOData: action.setInfo.maxUpdateStampOData,
        updateStampOText: action.setInfo.maxUpdateStampOText,
        updateStampUData: action.setInfo.maxUpdateStampUData,
        updateStampUText: action.setInfo.maxUpdateStampUText
      });
    case ActionTypes.SPORT_EVENT_SET_LIVE_THIRD_PARTITION_SET:
      processedItems = processThirdSetData(action.setInfo, state);

      return updateObject(state, {
        activeLiveSports: processedItems.pickerInfos,
        liveMatchesList: processedItems.liveEventList,
        allBets: processedItems.allBets,
        updateStampKData: action.setInfo.maxUpdateStampKData,
        updateStampOData: action.setInfo.maxUpdateStampOData,
        updateStampOText: action.setInfo.maxUpdateStampOText,
        updateStampUData: action.setInfo.maxUpdateStampUData,
        updateStampUText: action.setInfo.maxUpdateStampUText
      });
    case ActionTypes.SPORT_EVENT_SET_PREMATCH_PICKER_ITEMS:
      return updateObject(state, { activePrematchSports: action.pickerInfo });
    case ActionTypes.SPORT_EVENT_SET_ALL_BETS_TEXT:
      return updateObject(state, { allBetsText: action.allBetsText });
    case ActionTypes.SPORT_EVENT_SET_PREMATCH_LEAGUE_INFO:
      return updateObject(state, {
        prematchLeagueItems: action.leagueInfo,
        updateTimestamp: new Date()
      });
    case ActionTypes.SPORT_EVENT_SET_PREMATCH_CATEGORIES_INFO:
      return updateObject(state, {
        prematchCategories: action.categories,
        updateTimestamp: new Date()
      });
    default:
      return state;
  }
};

const processInitialSetData = data => {
  let sports = data.Sportovi;
  let matches = data.UtakmiceUTijekuData;
  let coefs = data.Koeficijenti;
  let matchesText = data.UtakmiceUTijekuText;
  let activeMatches = matches.filter(
    x => x.UTijeku === 1 && x.AktivnoW === true
  );
  let pickerInfos = [];
  let matchInfos = [];
  let allBetsText = data.OkladaTxt;
  let allBets = data.Oklade;

  //iteriraj kroz svaku
  for (let i = 0; i < activeMatches.length; i++) {
    const match = activeMatches[i];

    if (match.IDUtakmica === 15215737) {
      console.log("MATCH ", match);
    }

    //
    // PICKER INFOS
    //

    //vidi jel vec imas u picker infu za taj sport
    let pi = pickerInfos.find(x => x.sportID === match.SportID);

    if (pi === undefined) {
      //nadji sport i stvori ga
      let sport = sports.find(x => x.IDSport === match.SportID);

      if (sport === undefined) {
        //popuni dummy element
        pickerInfos.push({
          sportID: match.SportID,
          title: "?? " + match.sportID,
          matchCount: 1,
          UIOrderIndex: 0
        });
      } else {
        //popuni pravi element
        pickerInfos.push({
          sportID: match.SportID,
          title: sport.Naziv,
          matchCount: 1,
          UIOrderIndex: sport.RedoslijedUI,
          numberOfMainBets: sport.BrojTipova
        });

        //duplic reda radi zaasd
        //popuni pravi element
        // pickerInfos.push({
        //   sportID: match.SportID,
        //   title: sport.Naziv,
        //   matchCount: 1,
        //   UIOrderIndex: sport.RedoslijedUI
        // });
      }
    } else {
      //updateaj samo
      pi.matchCount++;
    }

    //
    // MATCH INFOS
    //

    //dohvati za tu utakmicu:
    //utakmicatext
    let matchText = matchesText.find(x => x.IDUtakmica === match.IDUtakmica);

    //oklada
    // let bet = bets.find(x => x.UtakmicaID === match.IDUtakmica);

    // if (bet === undefined) {
    //   console.log(
    //     "UNDEFINED BET FOR " + match.IDUtakmica,
    //     " WHICH IS SPORT " + match.SportID
    //   );
    //   continue;
    // }

    // //okladatxt
    // let betText = betsText.find(x => x.svoID === bet.svoID);

    // //koeficijent
    // let matchCoefs = coefs.filter(x => x.OkladaID === bet.IDOklada);

    //skroji matchinfoitem
    var matchInfoItem = {};

    //test start
    let filteredCoefs = coefs.filter(x => x.UtakmicaID === match.IDUtakmica);

    if (match.SportID === 1) {
      //dummy ubij
      let betInfo = [];

      for (let k = 0; k < filteredCoefs.length; k++) {
        const c = filteredCoefs[k];

        betInfo.push({
          id: c.IDKoeficijent,
          isActive: c.Aktivno,
          longName: c.DugiNaziv,
          shortName: c.Naziv,
          kategorijaPonudeID: c.KategorijaPonudeID,
          betID: c.OkladaID,
          isEnabled: c.Omoguciti,
          isShown: c.Prikazati,
          order: c.Redoslijed,
          sportVrstaOkladaID: c.SportVrstaOkladaID,
          matchID: c.UtakmicaID,
          value: c.Vrijednost,
          changeDirection: 0
        });
      }

      //pripremi rezu na poluvremenu ako ima
      var tmp1stHalf = match.TenisRezultatSet
        ? match.TenisRezultatSet.split(" ")[0]
        : "-:-";
      var tmpRez = tmp1stHalf.split(":");

      //soccer
      matchInfoItem = {
        id: match.IDUtakmica,
        sportID: match.SportID,
        homeTeam: matchText.TimDomacinNaziv,
        guestTeam: matchText.TimGostNaziv,
        tournamentName: matchText.TurnirNaziv,
        timeMatchStartDiff: matchText.vrijemePocetkaUtakmiceDiff,
        currentTime: match.TrenutnoVrijemeUtakmice,
        scoreHome: match.TrenutniRezultatUtakmiceDomacin,
        scoreGuest: match.TrenutniRezultatUtakmiceGost,
        scoreHalfTimeHome: tmpRez[0],
        scoreHalfTimeGuest: tmpRez[1],
        yellowCardsHome: match.x_ZutiDomacin,
        yellowCardsGuest: match.x_ZutiGost,
        redCardsHome: match.x_CrveniDomacin,
        redCardsGuest: match.x_CrveniGost,
        cornersHome: match.x_KorneriDomacin,
        cornersGuest: match.x_KorneriGost,
        yellowToRedCardsHome: match.x_ZutoCrveniDomacin,
        yellowToRedCardsGuest: match.x_ZutoCrveniGost,
        specFlagHome: match.SpecFlagsDomacin,
        specFlagGuest: match.SpecFlagsGost,
        betInfo: betInfo,
        extraBetsCount: match.cntPosebna
      };

      //console.log("BET TEXT ", betText);
      //console.log("COEFS  ", matchCoefs);

      matchInfos.push(matchInfoItem);
    } else {
      //other
      //dummy ubij
      let betInfo = [];

      //set info dohvati
      let currentGemInfo =
        match.TenisRezultat !== null
          ? match.TenisRezultat.split(":")
          : ["", ""];
      let totalScoreInfo =
        match.TenisRezultatAktivni !== null
          ? match.TenisRezultatAktivni.split(":")
          : ["", ""];
      let allSetsInfo =
        match.TenisRezultatSet !== null
          ? match.TenisRezultatSet.split(" ")
          : ["", ""];

      let setInfo = [];
      let setID = 0;
      for (let idx = 0; idx < allSetsInfo.length; idx++) {
        const info = allSetsInfo[idx].split(":");
        setID++;

        setInfo.push({
          homeScore: info[0],
          guestScore: info[1],
          isCurrentSet: idx === allSetsInfo.length - 1,
          id: setID
        });
      }

      matchInfoItem = {
        id: match.IDUtakmica,
        sportID: match.SportID,
        homeTeam: matchText.TimDomacinNaziv,
        guestTeam: matchText.TimGostNaziv,
        tournamentName: matchText.TurnirNaziv,
        timeMatchStartDiff: matchText.vrijemePocetkaUtakmiceDiff,
        currentTime: match.TrenutnoVrijemeUtakmice,
        betInfo: betInfo,
        setInfo: setInfo,
        scoreTotalHome: totalScoreInfo[0],
        scoreTotalGuest: totalScoreInfo[1],
        scoreGemHome: currentGemInfo[0].replace("50", "AD"),
        scoreGemGuest: currentGemInfo[1].replace("50", "AD"),
        homeHasServe: match.SpecFlagsDomacin === "1",
        guestHasServe: match.SpecFlagsGost === "1",
        extraBetsCount: match.cntPosebna
      };

      //console.log("BET TEXT ", betText);
      //console.log("COEFS  ", matchCoefs);

      matchInfos.push(matchInfoItem);
    }

    //matchInfos.push(matchInfoItem);

    // id: matchID,
    // homeTeam: clubs[Math.floor(Math.random() * 14)],
    // guestTeam: clubs[Math.floor(Math.random() * 14)],
    // currentMinute:
    //   (Math.floor(Math.random() * 90) + 1).toFixed(0) + "",
    // scoreHome: (Math.floor(Math.random() * 5) + 0).toFixed(0),
    // scoreGuest: (Math.floor(Math.random() * 5) + 0).toFixed(0),
    // yellowCardsHome: (Math.floor(Math.random() * 3) + 0).toFixed(0),
    // yellowCardsGuest: (Math.floor(Math.random() * 3) + 0).toFixed(0),
    // redCardsHome: (Math.floor(Math.random() * 2) + 0).toFixed(0),
    // redCardsGuest: (Math.floor(Math.random() * 2) + 0).toFixed(0),
    // betInfo: betInfo
  }

  //dodaj mu uvijek rucno lmw
  pickerInfos.push({
    sportID: 1000,
    title: "Lotto Instant Win",
    UIOrderIndex: 1000
  });

  return {
    pickerInfos: pickerInfos,
    liveEventList: matchInfos,
    allBetsText: allBetsText,
    allBets: allBets
  };
};

const processThirdSetData = (data, state) => {
  //console.log("DATA RECEIVED: ", data);

  let sports = state.initialLiveSetInfo.Sportovi;
  let matches = data.UtakmiceUTijekuData;
  let coefs = data.Koeficijenti;
  let bets = data.Oklade;
  //let betsText = state.initialLiveSetInfo.OkladaTxt;
  let matchesText = data.UtakmiceUTijekuText;
  //let activeMatches = matches.filter(x => x.UTijeku === 1);
  let pickerInfos = [];
  //let matchInfos = [];
  let updatedMatchList = state.liveMatchesList;
  let updatedBetsList = state.allBets;

  //console.log("MATCHES AT THE START: ", updatedMatchList);

  let tempCoefs = coefs.filter(x => x.OkladaID === 479724213);

  //console.log("TEMP COEFS ", tempCoefs);

  //console.log("Third set coefs: ", coefs);

  //console.log("SPORTS: ", sports);

  //idi po svim novim mecevima i updateaj postojece!
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];

    if (match.SportID === 1) {
      //console.log("MATCH NEW INFO ", match);
    }

    //pronadji stari data
    let oldMatchInfo = updatedMatchList.find(x => x.id === match.IDUtakmica);
    let oldMatchInfoIndex = updatedMatchList.findIndex(
      x => x.id === match.IDUtakmica
    );

    //console.log("MATCH OLD INFO ", match);

    if (oldMatchInfo !== undefined) {
      //console.log(new Date() + " OK! UPDATING MATCH INFO ", match);

      if (match.SportID === 1) {
        //console.log("FOOTBALL NEW INFO ", match);

        //pripremi rezu na poluvremenu ako ima
        var tmp1stHalf = match.TenisRezultatSet
          ? match.TenisRezultatSet.split(" ")[0]
          : "-:-";
        var tmpRez = tmp1stHalf.split(":");

        oldMatchInfo.homeChangeDirection =
          match.TrenutniRezultatUtakmiceDomacin > oldMatchInfo.scoreHome
            ? 1
            : 0;
        oldMatchInfo.guestChangeDirection =
          match.TrenutniRezultatUtakmiceGost > oldMatchInfo.scoreGuest ? 1 : 0;
        oldMatchInfo.currentTime = match.TrenutnoVrijemeUtakmice;
        oldMatchInfo.scoreHome = match.TrenutniRezultatUtakmiceDomacin;
        oldMatchInfo.scoreGuest = match.TrenutniRezultatUtakmiceGost;
        oldMatchInfo.yellowCardsHome = match.x_ZutiDomacin;
        oldMatchInfo.yellowCardsGuest = match.x_ZutiGost;
        oldMatchInfo.scoreHalfTimeHome = tmpRez[0];
        oldMatchInfo.scoreHalfTimeGuest = tmpRez[1];
        oldMatchInfo.redCardsHome = match.x_CrveniDomacin;
        oldMatchInfo.redCardsGuest = match.x_CrveniGost;
        oldMatchInfo.cornersHome = match.x_KorneriDomacin;
        oldMatchInfo.cornersGuest = match.x_KorneriGost;
        oldMatchInfo.yellowToRedCardsHome = match.x_ZutoCrveniDomacin;
        oldMatchInfo.yellowToRedCardsGuest = match.x_ZutoCrveniGost;
        oldMatchInfo.specFlagHome = match.SpecFlagsDomacin;
        oldMatchInfo.specFlagGuest = match.SpecFlagsGost;
        oldMatchInfo.extraBetsCount = match.cntPosebna;
      } else {
        //updateaj kurce
        //set info dohvati
        let currentGemInfo =
          match.TenisRezultat !== null
            ? match.TenisRezultat.split(":")
            : ["", ""];
        let totalScoreInfo =
          match.TenisRezultatAktivni !== null
            ? match.TenisRezultatAktivni.split(":")
            : ["", ""];
        let allSetsInfo =
          match.TenisRezultatSet !== null
            ? match.TenisRezultatSet.split(" ")
            : ["", ""];

        let setInfo = [];
        let setID = 0;
        for (let idx = 0; idx < allSetsInfo.length; idx++) {
          const info = allSetsInfo[idx].split(":");
          setID++;

          setInfo.push({
            homeScore: info[0],
            guestScore: info[1],
            isCurrentSet: idx === allSetsInfo.length - 1,
            id: setID
          });
        }

        oldMatchInfo.homeChangeDirection =
          parseInt(totalScoreInfo[0], 10) > oldMatchInfo.scoreTotalHome ? 1 : 0;
        oldMatchInfo.guestChangeDirection =
          parseInt(totalScoreInfo[1], 10) > oldMatchInfo.scoreTotalGuest
            ? 1
            : 0;
        oldMatchInfo.id = match.IDUtakmica;
        oldMatchInfo.sportID = match.SportID;
        oldMatchInfo.currentTime = match.TrenutnoVrijemeUtakmice;
        oldMatchInfo.setInfo = setInfo;
        oldMatchInfo.scoreTotalHome = totalScoreInfo[0];
        oldMatchInfo.scoreTotalGuest = totalScoreInfo[1];
        oldMatchInfo.scoreGemHome = currentGemInfo[0].replace("50", "AD");
        oldMatchInfo.scoreGemGuest = currentGemInfo[1].replace("50", "AD");
        oldMatchInfo.homeHasServe = match.SpecFlagsDomacin === "1";
        oldMatchInfo.guestHasServe = match.SpecFlagsGost === "1";
        oldMatchInfo.extraBetsCount = match.cntPosebna;
      }

      //ako je gotova, bacaj van
      if (match.UTijeku !== 1 || match.AktivnoW === false) {
        updatedMatchList.splice(oldMatchInfoIndex, 1);
      }
    } else {
      //nova utakmica
      if (match.UTijeku !== 1 || match.AktivnoW === false) {
        //console.log("UNDEFINED MATCH INFO; NOT ADDING MATCH BECAUSE NOT STARTED! ",match);
        continue;
      }

      //console.log("UNDEFINED MATCH INFO FOR MATCH WITH ID; ADDING A NEW MATCH! ",match);

      let matchText = matchesText.find(x => x.IDUtakmica === match.IDUtakmica);

      //skroji matchinfoitem
      var matchInfoItem = {};

      //test start
      let filteredCoefs = coefs.filter(x => x.UtakmicaID === match.IDUtakmica);

      if (match.IDUtakmica === 14894565) {
        console.log("FILTROVANI SU ", filteredCoefs);
      }

      if (match.SportID === 1) {
        //dummy ubij
        let betInfo = [];

        for (let k = 0; k < filteredCoefs.length; k++) {
          var c = filteredCoefs[k];

          betInfo.push({
            id: c.IDKoeficijent,
            isActive: c.Aktivno,
            longName: c.DugiNaziv,
            shortName: c.Naziv,
            kategorijaPonudeID: c.KategorijaPonudeID,
            betID: c.OkladaID,
            isEnabled: c.Omoguciti,
            isShown: c.Prikazati,
            order: c.Redoslijed,
            sportVrstaOkladaID: c.SportVrstaOkladaID,
            matchID: c.UtakmicaID,
            value: c.Vrijednost,
            changeDirection: 0
          });
        }

        //pripremi rezu na poluvremenu ako ima
        var tmp1stHalf = match.TenisRezultatSet
          ? match.TenisRezultatSet.split(" ")[0]
          : "-:-";
        var tmpRez = tmp1stHalf.split(":");

        //soccer
        matchInfoItem = {
          id: match.IDUtakmica,
          sportID: match.SportID,
          homeTeam: matchText.TimDomacinNaziv,
          guestTeam: matchText.TimGostNaziv,
          tournamentName: matchText.TurnirNaziv,
          timeMatchStartDiff: matchText.vrijemePocetkaUtakmiceDiff,
          currentTime: match.TrenutnoVrijemeUtakmice,
          scoreHome: match.TrenutniRezultatUtakmiceDomacin,
          scoreGuest: match.TrenutniRezultatUtakmiceGost,
          yellowCardsHome: match.x_ZutiDomacin,
          yellowCardsGuest: match.x_ZutiGost,
          scoreHalfTimeHome: tmpRez[0],
          scoreHalfTimeGuest: tmpRez[1],
          redCardsHome: match.x_CrveniDomacin,
          redCardsGuest: match.x_CrveniGost,
          cornersHome: match.x_KorneriDomacin,
          cornersGuest: match.x_KorneriGost,
          yellowToRedCardsHome: match.x_ZutoCrveniDomacin,
          yellowToRedCardsGuest: match.x_ZutoCrveniGost,
          specFlagHome: match.SpecFlagsDomacin,
          specFlagGuest: match.SpecFlagsGost,
          betInfo: betInfo,
          extraBetsCount: match.cntPosebna
        };

        //console.log("BET TEXT ", betText);
        //console.log("COEFS  ", matchCoefs);

        updatedMatchList.push(matchInfoItem);
      } else {
        //other
        //dummy ubij
        let betInfo = [];

        //set info dohvati
        let currentGemInfo =
          match.TenisRezultat !== null
            ? match.TenisRezultat.split(":")
            : ["", ""];
        let totalScoreInfo =
          match.TenisRezultatAktivni !== null
            ? match.TenisRezultatAktivni.split(":")
            : ["", ""];
        let allSetsInfo =
          match.TenisRezultatSet !== null
            ? match.TenisRezultatSet.split(" ")
            : ["", ""];

        let setInfo = [];
        let setID = 0;
        for (let idx = 0; idx < allSetsInfo.length; idx++) {
          const info = allSetsInfo[idx].split(":");
          setID++;

          setInfo.push({
            homeScore: info[0],
            guestScore: info[1],
            isCurrentSet: idx === allSetsInfo.length - 1,
            id: setID
          });
        }

        matchInfoItem = {
          id: match.IDUtakmica,
          sportID: match.SportID,
          homeTeam: matchText ? matchText.TimDomacinNaziv : "",
          guestTeam: matchText ? matchText.TimGostNaziv : "",
          tournamentName: matchText ? matchText.TurnirNaziv : "",
          timeMatchStartDiff: matchText ? matchText.vrijemePocetkaUtakmiceDiff : 0,
          currentTime: match.TrenutnoVrijemeUtakmice,
          betInfo: betInfo,
          setInfo: setInfo,
          scoreTotalHome: totalScoreInfo[0],
          scoreTotalGuest: totalScoreInfo[1],
          scoreGemHome: currentGemInfo[0].replace("50", "AD"),
          scoreGemGuest: currentGemInfo[1].replace("50", "AD"),
          homeHasServe: match.SpecFlagsDomacin === "1",
          guestHasServe: match.SpecFlagsGost === "1",
          extraBetsCount: match.cntPosebna
        };

        //console.log("BET TEXT ", betText);
        //console.log("COEFS  ", matchCoefs);

        updatedMatchList.push(matchInfoItem);
      }
    }
  }

  //sve kvote prvo resetiraj na nulu
  for (let i = 0; i < updatedMatchList.length; i++) {
    const element = updatedMatchList[i];
    for (let j = 0; j < element.betInfo.length; j++) {
      element.betInfo[j].changeDirection = 0;
    }
  }

  //updateaj kvote
  for (let i = 0; i < coefs.length; i++) {
    const c = coefs[i];

    if (c.OkladaID === 479724213) {
      console.log("OBRADA OKLADE... ", c);
    }

    let newInfo = {
      id: c.IDKoeficijent,
      isActive: c.Aktivno,
      longName: c.DugiNaziv,
      shortName: c.Naziv,
      kategorijaPonudeID: c.KategorijaPonudeID,
      betID: c.OkladaID,
      isEnabled: c.Omoguciti,
      isShown: c.Prikazati,
      order: c.Redoslijed,
      sportVrstaOkladaID: c.SportVrstaOkladaID,
      matchID: c.UtakmicaID,
      value: c.Vrijednost,
      changeDirection: 0
    };

    //dohvati taj mec
    var tmpMatch = updatedMatchList.find(x => x.id === newInfo.matchID);

    if (tmpMatch) {
      //nadji taj stari coef
      let oldCoefIdx = tmpMatch.betInfo.findIndex(x => x.id === newInfo.id);

      if (oldCoefIdx >= 0) {
        //update
        //dohvati stari
        let oldInfo = tmpMatch.betInfo[oldCoefIdx];

        //usporedi
        if (newInfo.value > oldInfo.value) {
          newInfo.changeDirection = 1;
        } else if (newInfo.value < oldInfo.value) {
          newInfo.changeDirection = -1;
        } else {
          newInfo.changeDirection = 0;
        }

        //replace
        tmpMatch.betInfo[oldCoefIdx] = newInfo;
      } else {
        //insert
        tmpMatch.betInfo.push(newInfo);
      }
    }
  }

  //idi i po svim okladama i replaceaj
  for (let i = 0; i < bets.length; i++) {
    const updatedBet = bets[i];

    //nadji index da vidis ako je vec bila
    let idx = updatedBetsList.findIndex(
      x => x.IDOklada === updatedBet.IDOklada
    );

    if (idx >= 0) {
      //update
      updatedBetsList[idx] = updatedBet;
    } else {
      //insert
      updatedBetsList.push(updatedBet);
    }
  }

  //prodji po updated match list i azuriraj picker infos
  for (let i = 0; i < updatedMatchList.length; i++) {
    const match = updatedMatchList[i];

    //console.log(match);

    //vidi jel vec imas u picker infu za taj sport
    let pi = pickerInfos.find(x => x.sportID === match.sportID);

    if (pi === undefined) {
      //nadji sport i stvori ga
      let sport = sports.find(x => x.IDSport === match.sportID);

      if (sport === undefined) {
        //popuni dummy element
        pickerInfos.push({
          sportID: match.sportID,
          title: "?? " + match.sportID,
          matchCount: 1,
          UIOrderIndex: 0
        });
      } else {
        //popuni pravi element
        pickerInfos.push({
          sportID: match.sportID,
          title: sport.Naziv,
          matchCount: 1,
          UIOrderIndex: sport.RedoslijedUI,
          numberOfMainBets: sport.BrojTipova
        });
      }
    } else {
      //updateaj samo
      pi.matchCount++;
    }
  }

  //dodaj mu uvijek rucno lmw
  pickerInfos.push({
    sportID: 1000,
    title: "Lotto Instant Win",
    UIOrderIndex: 1000
  });

  //console.log("MATCHES AT THE END: ", updatedMatchList);

  //console.log("UPDATED BETS: ", updatedBetsList);
  return {
    pickerInfos: pickerInfos,
    liveEventList: updatedMatchList,
    allBets: updatedBetsList
  };
  //return { pickerInfos: pickerInfos, liveEventList: matchInfos };
};

export default reducer;



// WEBPACK FOOTER //
// ./src/ReduxStore/Reducers/SportEventReducer.js